import React from 'react';
import firebase from 'firebase';
import Login from './Login';
import base, {firebaseApp} from "../base";
import AddSkill from "./AddSkill";

class UpdateDetails extends React.Component {

  state = {
    skills: {},
    uid: null
  };

  gethomepageDescription = async () => {
    var homeDesc=null;
    const homepageDescription = await base.fetch('homepageDescription', {context: this}).then(res => {
      //console.log(res);
      homeDesc = res;
    })
    document.getElementById("descriptionForm-homepageDescription").value = homeDesc;
    //console.log("UPDATE 1: " + homeDesc);
    //return homeDesc;
  };

  getaboutmeDescription = async () => {
    var aboutMeDesc=null;
    const aboutMeDescription = await base.fetch('aboutMeDescription', {context: this}).then(res => {
      console.log(res);
      aboutMeDesc = res;
    })
    //console.log("desc: " + aboutMeDesc);
    document.getElementById("descriptionForm-aboutMeDescription").value = aboutMeDesc;
    //console.log("UPDATE 2: " + aboutMeDesc);
    //return aboutMeDesc;
  };

  handleUpdate = async (event) => {

    event.preventDefault();
    console.log("HOMEPAGE: " + document.getElementById('descriptionForm-homepageDescription').value);
    console.log("ABOUT ME: " + document.getElementById('descriptionForm-aboutMeDescription').value);

    await base.post("homepageDescription", {
      data: document.getElementById('descriptionForm-homepageDescription').value
    });

    await base.post("aboutMeDescription", {
      data: document.getElementById('descriptionForm-aboutMeDescription').value
    });
  }

  componentDidMount() {
    this.ref = base.syncState('skills', {
      context: this,
      state: 'skills'
    });
  }

  componentDidUpdate() {
    if(this.state.uid === "nishantgoyal918@gmail.com") {
      this.gethomepageDescription();
      this.getaboutmeDescription();
    }
  }

  addSkill = (skill) => {
    const skills = {... this.state.skills};
    skills[`skill${Date.now()}`] = skill;
    this.setState({
      skills: skills
    });
  }

  authHandler = async (authData) => {
    this.setState({
      uid: authData.user.email
    });
    console.log("USER: " + JSON.stringify(authData));
  }

  authenticate = () => {
    const authProvider = new firebase.auth["GithubAuthProvider"]();
    firebaseApp.auth().signInWithPopup(authProvider).then(this.authHandler);
  }

  logoutUser = () => {
    this.setState({
      uid: null
    });
  }

  render() {

    console.log("UID: " + this.state.uid);

    if(!this.state.uid) {
        return (
          <Login authenticate={this.authenticate}/>
      );
    }

    if(this.state.uid != "nishantgoyal918@gmail.com") {
      return (
        <div className="updateDetails-wrong-user">
          <p>Sorry, you cannot edit details here!</p>
        <button className="updateDetails-logout" onClick={this.logoutUser}>Logout!</button>
        </div>
      );
    }

    return (
      <div className="updateDetails-main">
        <form className="updateDetails-main-descriptionForm">
          <span>Homepage Description: </span><textarea className="updateDetails-main-descriptionForm-textarea" id="descriptionForm-homepageDescription"></textarea>
          <span>About Me Description: </span><textarea className="updateDetails-main-descriptionForm-textarea" id="descriptionForm-aboutMeDescription"></textarea>
          <button onClick={this.handleUpdate}>Update</button>
        </form>
        <AddSkill addSkill={this.addSkill}/>
        <button className="updateDetails-logout" onClick={this.logoutUser}>Logout!</button>
      </div>
    );
  }
}

export default UpdateDetails;
